var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0l4.323 6.788 6.659-4.41 1.238 7.991 7.845-1.27-2.06 7.814 7.673 2.089-5.002 6.285 6.176 5.088-7.08 3.668 3.61 7.207-7.932.419.42 8.079-7.414-2.904-2.842 7.555L27 48.675l-5.614 5.724-2.842-7.555-7.414 2.904.42-8.08-7.933-.418 3.61-7.207-7.08-3.668 6.177-5.088-5.003-6.285 7.674-2.09L6.935 9.1l7.845 1.27 1.238-7.992 6.66 4.41L27 0z"
  })));
}
export default SvgStarElement;